import { render, staticRenderFns } from "./RichMenuIndex.vue?vue&type=template&id=3b24bbfa&scoped=true&"
import script from "./RichMenuIndex.vue?vue&type=script&lang=js&"
export * from "./RichMenuIndex.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuIndex.vue?vue&type=style&index=0&id=3b24bbfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24bbfa",
  null
  
)

export default component.exports